// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__ZNpe0","buttons":"SendReceipts_buttons__2siRb","email":"SendReceipts_email__1MPn5","bookApptTitle":"SendReceipts_bookApptTitle__1GUlZ"};